// @core
import { i18n } from "core/i18n";
import PropTypes from "prop-types";

// @constants
import { INTERVENER_TITLE } from "constants/interveners";

// @components
import { OKMessage, MESSAGE_TYPE_ASSISTANT } from 'commonsComponents/OKMessage'
import ContactCenterRender from "components/conditionalRender/contactCenterRender"
import SummaryList from "components/commons/summaryList/summaryList";
import SummaryListItem from "components/commons/summaryListItem/summaryListItem";

import './settingResumeStep.scss';

const { FormattedText, formatText } = i18n;

const buildIntervenerGroup = (immGroup) => {
    const type = immGroup.first().get('rawType');
    const title = INTERVENER_TITLE[type];

    const interveners = immGroup.map(immIntervener => (
        <div className='transfer-account__setting-resume__interveners-item' key={immIntervener.get('name').toString()}>
            {immIntervener.get('name')}
        </div>
    ));

    return (
        <div>
            <FormattedText className='transfer-account__setting-resume__group-title' value={title} />
            {interveners}
        </div>
    );
}

const SettingResumeRight = ({ immAccount }) => {
    const interveners = immAccount.getIn(['interveners', 'list'])
    const intervenersList = interveners.groupBy(intervener => intervener.get('rawType')).map((intervenerGroup) => buildIntervenerGroup(intervenerGroup)).toArray()

    return (
        <div>
            <p className='transfer-account__setting-resume__interveners-title'>
                <FormattedText value="transfer_account-transfer_account_from_another_bank_step2_interveners_text" />
            </p>
            {intervenersList}
        </div>
    )
}

const SettingResumeLeft = ({ immAccount }) => {
    const accountAlias = immAccount.get('alias')
    const accountIban = immAccount.get('iban')

    return (
        <>
            <SummaryListItem
                text={formatText('transfer_account-transfer_account_from_another_bank_step2_alias_text')}
                value={accountAlias}
            />
            <SummaryListItem
                text={formatText('transfer_account-transfer_account_from_another_bank_step2_iban_text')}
                value={accountIban}
            />
        </>
    );
}


export const SettingResumeStep = ({ immAccount, isOffice }) => {
    const disclaimerDescription = isOffice
        ? 'transfer_account_oficina-transfer_account_from_another_bank_step2_disclaimer_of'
        : 'transfer_account_cc-transfer_account_from_another_bank_step2_disclaimer_cc'

    return (
        <div className="transfer-account__setting-resume">
            <section className='transfer-account__setting-resume__summary'>
                <h2 className='transfer-account__setting-resume__title'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step2_subtitle" />
                </h2>
                <p className='transfer-account__setting-resume__subtitle'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step2_description" />
                </p>
                <ContactCenterRender>
                    <div className="transfer-account__setting-resume__disclaimer">
                        <OKMessage className="transfer-account__setting-resume__disclaimer" type={MESSAGE_TYPE_ASSISTANT}>
                            <FormattedText value={disclaimerDescription} />
                        </OKMessage>
                    </div>
                </ContactCenterRender>
                <section className='transfer-account__setting-resume__summary-data'>
                    <SummaryList rightColumn={<SettingResumeRight immAccount={immAccount} />} leftColumn={<SettingResumeLeft immAccount={immAccount} />} />
                </section>
            </section>
        </div>
    );
}

SettingResumeStep.propTypes = {
    immAccount: PropTypes.object.isRequired,
    isOffice: PropTypes.bool.isRequired,
};
